document.addEventListener("DOMContentLoaded", function () {
  const prefixes = ["gh-tag-carousel", "gh-tag-post-list"];

  prefixes.forEach((prefix) => {
    processTagTitles(prefix);
  });
});

function processTagTitles(prefix) {
  const tagCarousels = document.querySelectorAll(`.${prefix}`);

  tagCarousels.forEach((carousel) => {
    const header = carousel.querySelector(`.${prefix}-header`);

    if (header) {
      const tagName = header.getAttribute("data-tag-name");
      const titleContainer = header.querySelector(`.${prefix}-title-container`);

      if (tagName && titleContainer && tagName.includes("|")) {
        const parts = tagName.split("|").map((part) => part.trim());

        titleContainer.innerHTML = "";

        if (parts[0]) {
          const subtitle = document.createElement("h3");
          subtitle.className = `${prefix}-subtitle`;
          subtitle.textContent = parts[0];
          titleContainer.appendChild(subtitle);
        }

        if (parts[1]) {
          const title = document.createElement("h2");
          title.className = `${prefix}-title`;
          title.textContent = parts[1];
          titleContainer.appendChild(title);
        }
      }
    }
  });
}
